import { render } from "./ChromaticsComponent.vue?vue&type=template&id=6c548046&scoped=true"
import script from "./ChromaticsComponent.vue?vue&type=script&lang=js"
export * from "./ChromaticsComponent.vue?vue&type=script&lang=js"

import "./ChromaticsComponent.vue?vue&type=style&index=0&id=6c548046&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c548046"]])

export default __exports__